const ASSETS = {
  icon_inclusive_access_gif: require("../../assets/icons/people-celebrating.gif"),
  icon_inclusive_access_png: require("../../assets/icons/people-celebrating.png"),
  icon_collaborative_learning_gif: require("../../assets/icons/fist-bump.gif"),
  icon_collaborative_learning_png: require("../../assets/icons/fist-bump.png"),
  icon_challenges_gif: require("../../assets/icons/puzzle-pieces.gif"),
  icon_challenges_png: require("../../assets/icons/puzzle-pieces.png"),
  

  icon_success_gif: require("../../assets/icons/double-check.gif"),
  icon_success_png: require("../../assets/icons/double-check.png"),
  icon_error_gif: require("../../assets/icons/x.gif"),
  icon_error_png: require("../../assets/icons/x.png"),
  icon_alarm_gif: require("../../assets/icons/alarm.gif"),
  icon_alarm_png: require("../../assets/icons/alarm.png"),
  icon_info_gif: require("../../assets/icons/info.gif"),
  icon_info_png: require("../../assets/icons/info.png"),
  icon_gears_gif: require("../../assets/icons/gears.gif"),
  icon_gears_png: require("../../assets/icons/gears.png"),
  icon_logout_gif: require("../../assets/icons/logout.gif"),
  icon_logout_png: require("../../assets/icons/logout.png"),
  icon_notification_gif: require("../../assets/icons/notification.gif"),
  icon_notification_png: require("../../assets/icons/notification.png"),
  icon_mail_gif: require("../../assets/icons/mail.gif"),
  icon_mail_png: require("../../assets/icons/mail.png"),
  icon_online_class_gif: require("../../assets/icons/online-class.gif"),
  icon_online_class_png: require("../../assets/icons/online-class.png"),
  icon_question_gif: require("../../assets/icons/question.gif"),
  icon_question_png: require("../../assets/icons/question.png"),
  icon_brain_light_gif: require("../../assets/icons/brain_light.gif"),
  icon_brain_light_png: require("../../assets/icons/brain_light.png"),
  icon_instructions_gif: require("../../assets/icons/instructions.gif"),
  icon_instructions_png: require("../../assets/icons/instructions.png"),

  icon_data_gif: require("../../assets/icons/data.gif"),
  icon_data_png: require("../../assets/icons/data.png"),
  icon_unauthorized_png: require("../../assets/icons/unauthorized.png"),
  icon_assistance_png: require("../../assets/icons/assistance.png"),
  icon_letter_gif: require("../../assets/icons/letter.gif"),
  icon_letter_png: require("../../assets/icons/letter.png"),
  icon_feedback_gif: require("../../assets/icons/feedback-emoji.gif"),
  icon_feedback_png: require("../../assets/icons/feedback-emoji.png"),
  icon_loading_gif: require("../../assets/icons/loading.gif"),
  //
  first: require("../../assets/images/assessment/first.png"),
  second: require("../../assets/images/assessment/second.png"),
  third: require("../../assets/images/assessment/third.png"),
  times_up: require("../../assets/images/assessment/times-up.png"),
  tips: require("../../assets/images/assessment/tips.avif"),
  //
  masomo_banner: require("../../assets/images/masomo-banner.png"),
  masomo_banner2: require("../../assets/images/masomo-banner2.png"),
  // 
  for_pupils: require("../../assets/images/for_pupils.jpg"),
  for_parents: require("../../assets/images/for_parents.jpg"),
  for_lecturers: require("../../assets/images/for_lecturers.jpg"),
  // 
  signin: require("../../assets/images/signin.jpg"),
  signup: require("../../assets/images/signup.jpg"),
};

export default ASSETS;
